@use "../partials/colors-ev";
@use "../partials/mixins";

// google maps custom marker for each property
.price_marker {
  font-family: 'EngelVoelkersText', 'Switzer', 'Roboto', serif;
  @apply rounded-none px-2 py-1 bg-carbon text-white text-sm;

  &:hover {
    @apply bg-crimson;
  }

  // https://developers.google.com/maps/documentation/javascript/advanced-markers/html-markers
  &::after {
    content: "";
    position: absolute;
    left: 50%;
    top: 100%;
    transform: translate(-50%, 0);
    width: 0;
    height: 0;
    border-left: 8px solid transparent;
    border-right: 8px solid transparent;
    border-top: 8px solid colors-ev.$carbon;

    // make down-arrow same color on hover
    &:hover {
      @apply border-t-crimson;
    }
  }
}

// different background colors depending on number of properties in cluster
.cluster_marker {
  font-family: 'EngelVoelkersText', 'Switzer', 'Roboto', serif;
  @apply bg-crimson rounded-full font-bold text-white text-sm text-center h-9 w-9 leading-9;

  &:hover {
    background-color: colors-ev.$crimson-600 !important;
    color: white !important;
  }

  // 1 - 9
  &[class~="--l1"] {
    //@apply bg-[#B8B6B6] text-carbon;
    @apply bg-crimson text-white;
  }

  // 10 - 99
  &[class~="--l2"] {
    //@apply bg-[#747070] text-white;
    @apply bg-crimson text-white;
  }

  // 100+
  &[class~="--l3"] {
    @apply bg-crimson text-white;
  }
}

// google maps InfoWindow styler -- use default Google classes since we cannot set custom .module.scss classes;
// note: this affects ALL InfoWindows, including default Google ones for cities, etc.; so only style our own popups
[role='dialog'][class~=gm-style-iw]:has([class~=iw__body]) {
  padding: 0 !important;
  margin: 0 !important;
  @apply rounded-none;

  // InfoWindow header dialog
  //[class~=gm-style-iw-chr] {}

  // InfoWindow main body - remove space reserved for scrollbars
  [class~=gm-style-iw-d] {
    overflow: hidden !important;
  }

  // inside InfoWindow we use a Mui Card + ActionArea to make entire card clickable
  [class~=iw__body] > [class~=MuiCard-root] {
    &:hover {
      @apply bg-transparent;
    }

    // on-hover highlight
    [class~=MuiCardActionArea-focusHighlight] {
      @apply bg-transparent;
    }

    // effect on click
    [class~=MuiTouchRipple-child] {
      @apply bg-transparent;
    }
  }
}